// extracted by mini-css-extract-plugin
module.exports = {"component":"KeyManagementScreen_component__3A1ww"};